import React from 'react'
import Header from '../Header/Main'
import Breadcrumb from '../Breadcrumb/Main'
import AnalyticsAndPerformance from '../MenserviceAnalyticsAndPerformance/AnalyticsAndPerformance'
import Footer from '../Footer/Main'

function Main() {
    return (
        <>
            <div className="page-wrapper">
                <Header />
                <Breadcrumb subtitle="Home" title="Analytics and Performance Management" />
                <AnalyticsAndPerformance />
                <Footer />
            </div>
        </>
    )
}

export default Main